<template>
  <div>
    <div class="select-container text-center">
      <div
        class="dragable-con white--text rounded primary px-2 py-1 ma-2"
        draggable="true"
        @dragstart="dragStart($event)"
        v-for="(item, indx) in updated_items"
        :key="`${item[item_text]}_${indx}`"
        :id="`${indx}`"
        @drop="dragDrop($event)"
        @dragover="allowDrop($event)"
      >
        {{ item[item_text] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectVT",
  props: { items: Array, item_text: String },
  watch: {
    items: function (newVal) {
      this.updated_items = newVal;
    },
  },
  mounted() {
    this.updated_items = this.items;
  },
  data: function () {
    return { updated_items: null, move_from: null };
  },
  methods: {
    dragStart(ev) {
      this.move_from = ev.target.id;
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    dragDrop(ev) {
      ev.preventDefault();
      this.$emit("item_updated", [this.move_from, ev.target.id]);
      this.move_from = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.select-container {
  max-width: 80vw;

  .dragable-con {
    cursor: grab;
  }
}
</style>
